import { render, staticRenderFns } from "./Basic2.vue?vue&type=template&id=119d6ac5"
import script from "./Basic2.vue?vue&type=script&lang=ts"
export * from "./Basic2.vue?vue&type=script&lang=ts"
import style0 from "./Basic2.vue?vue&type=style&index=0&id=119d6ac5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports